export default __webpack_public_path__ + "static/christmas-stockings-a403266e74be22ba5f70a63452e2f050.png";